var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "bio-material-form-modify"
    }
  }, [_vm.removeMaterial ? _c('BioMaterialRemove', {
    attrs: {
      "material-type": _vm.materialType,
      "uuid": _vm.uuid,
      "group-nid": _vm.groupNid
    },
    on: {
      "submit-form-data": _vm.handleFormData,
      "form-error-message": _vm.handleFormError
    }
  }) : _c('BioMaterialForm', {
    attrs: {
      "group-nid": _vm.groupNid,
      "material-type": _vm.materialType,
      "uuid": _vm.uuid,
      "is-in-modal": true
    },
    on: {
      "choose-modification": function (e) {
        return _vm.$emit('choose-modification', e);
      },
      "emit-step-change": _vm.emitStepChange,
      "emit-close-modal": _vm.emitCloseModal,
      "remove-material": _vm.handleRemoveMaterial
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }